import {action, observable, reaction, makeObservable} from 'mobx';
import {getSearchResult, getQuickSearchFields} from '../actions/quickSearch';

export class QuickSearchStore {
    @observable isOpen: boolean = false;
    @observable isDropdownOpen: boolean = false;
    @observable results: any[] = [];
    @observable query: string = '';
    @observable isSearching: boolean = false;
    @observable numFound: number;

    quickSearchFields: string[];
    formName: string;

    constructor(formName, data?) {
        makeObservable(this);
        this.formName = formName;
        this.quickSearchFields = getQuickSearchFields(data);

        reaction(
            () => this.query,
            () => {
                this.getResults(this.query);
            }
        );
    }

    @action
    getResults = async (query: string) => {
        this.isSearching = true;
        const res = await getSearchResult(query, this.formName);
        this.setResults(res['docs'] ? res['docs'] : []);
        this.setNumFound(res['numFound']);
        this.isSearching = false;
    };

    @action
    setNumFound = num => {
        this.numFound = num;
    };

    @action
    setResults = results => {
        this.results = [...results];
    };

    @action init = () => {
        this.isOpen = false;
        this.isDropdownOpen = false;
        this.query = '';
        this.results = [];
    };
    @action setIsOpen = open => {
        this.isOpen = open;
    };

    @action setIsDropdownOpen = open => {
        this.isDropdownOpen = open;
    };

    @action setQuery = query => {
        this.query = query;
    };
}
